/**
 * Owner: Masa Bayu
 * File: resolve-wrap.ts
 * Date:Time: 2026-10-07 12:24
 * Description: QX-URP-02 CONTEXTUAL wrap · UNKNOWN never becomes nowrap.
 */

import type {
  PhysicalLineEvidence,
  PlacementModeEvidence,
  WrapPolicy,
} from './types';

export type WrapEvidence = {
  readonly preserveSource: boolean;
  readonly placementMode: PlacementModeEvidence;
  readonly physicalLine: PhysicalLineEvidence;
};

/**
 * Locked resolution (QX-URP-02 / QX-URP-03):
 *
 * preserveSource ∧ ABSOLUTE ∧ PROVEN_SINGLE_LINE → PHYSICAL_LINE_NO_WRAP
 * placementMode === FLOW → FLOW
 * otherwise → UNKNOWN
 *
 * NEVER: UNKNOWN → PHYSICAL_LINE_NO_WRAP
 */
export function resolveWrapPolicy(evidence: WrapEvidence): WrapPolicy {
  if (
    evidence.preserveSource === true &&
    evidence.placementMode === 'ABSOLUTE' &&
    evidence.physicalLine === 'PROVEN_SINGLE_LINE'
  ) {
    return 'PHYSICAL_LINE_NO_WRAP';
  }
  if (evidence.placementMode === 'FLOW') {
    return 'FLOW';
  }
  return 'UNKNOWN';
}
